import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';
import { installMockIfEnabled } from './lib/devMock/installMock';
import { runStartupDiagnostic } from './lib/startupDiagnostic';

Sentry.init({
  dsn: 'https://b8b884da24daaa5351f7577bc7ecfa1a@o4511077939216384.ingest.us.sentry.io/4511077945180160',
  sendDefaultPii: false,
  enabled: import.meta.env.PROD,
  beforeSend(event) {
    if (event.request) {
      delete event.request.data;
      delete event.request.headers;
    }
    if (event.exception?.values) {
      for (const exc of event.exception.values) {
        if (exc.stacktrace?.frames) {
          for (const frame of exc.stacktrace.frames) {
            delete frame.vars;
          }
        }
      }
    }
    return event;
  },
});

// Install the dev-mock interceptor BEFORE the first render. AuthProvider's
// mount effect calls fetch synchronously, so the interceptor must be in place
// by then. No-op unless VITE_MOCK=1.
installMockIfEnabled().finally(() => {
  const root = createRoot(document.getElementById('root')!);
  root.render(<App />);
  // Fire-and-forget; diagnostic logs go to the browser console.
  void runStartupDiagnostic();
});
